import styled from 'styled-components';
import { Breadcrumb, Button, Snackbar } from '@teamfabric/copilot-ui';
import { FunctionComponent, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from 'contexts/auth';
import { useCreateSchema, useDynamicSchema, useUpdateSchema } from 'utils/dynamicSchema';
import SchemaDetailsForm from 'components/DynamicSchemas/SchemaDetailsForm';

const Container = styled.div``;

const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
`;
const StyledSnackBarContainer = styled.div`
  .error-notification {
    margin-top: 12px;
    .label {
      color: white;
    }
    svg {
      fill: white;
      path {
        fill: white;
      }
    }
  }
`;

const DynamicSchemaDetails: FunctionComponent<Object> = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [errorTitle, setErrorTitle] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const { data, loading } = useDynamicSchema(user?.accountId);
  const [addNewSchema] = useCreateSchema(user?.accountId);
  const [updateSchema] = useUpdateSchema(user?.accountId);
  const onGoBack = () => {
    navigate('/schema/list');
  };

  const formEventHandlers = {
    onSubmit: values => {
      setErrorTitle('');
      const onError = err => {
        setErrorTitle(JSON.stringify(err?.graphQLErrors?.[0]?.title));
        setErrorMessage(JSON.stringify(err?.graphQLErrors?.[0]?.additionalInfo?.errors));
      };
      let promise;
      if (data?.Schema?.createdAt) {
        promise = updateSchema({
          variables: { id: user.accountId, schema: values },
        });
      } else {
        promise = addNewSchema({ variables: { schema: values } });
      }

      promise.then(onGoBack).catch(onError);
    },
  };

  return (
    <Container data-testid="dynamic-schema-details-view">
      <Breadcrumb
        backCaretHandler={onGoBack}
        data={[
          {
            label: 'ALL SCHEMA',
            onLabelClick: onGoBack,
          },
        ]}
      />
      <ActionsContainer>
        <Button
          type="button"
          isPrimary={false}
          onClick={onGoBack}
          text="Cancel"
          style={{ marginRight: '12px' }}
        />
        <Button
          type="submit"
          form="schemaDetailsForm"
          size="small"
          text="Save"
          data-testid="schema-details-save-button"
        />
      </ActionsContainer>
      {errorTitle && (
        <StyledSnackBarContainer data-testid="snackbar-container">
          <Snackbar
            dismissable
            className="error-notification"
            data-testid="errorTitle"
            height="auto"
            kind="message"
            label={`Error:  ${errorTitle}`}
            onDismiss={() => {
              setErrorTitle('');
            }}
            show
          >
            <Snackbar
              className="error-notification"
              data-testid="errorMsg"
              height="auto"
              kind="message"
              label={`Error info: ${errorMessage}`}
              show
              withIcon={false}
            />
          </Snackbar>
        </StyledSnackBarContainer>
      )}

      <SchemaDetailsForm schemaDetails={{ data, loading }} events={formEventHandlers} />
    </Container>
  );
};
export default DynamicSchemaDetails;
